import { fmhAPI, PERFORMANCE_API_URL } from 'api/APIBase';

/** Gets performance entries associated with a referral */
export function getPerformanceByReferralId(referralId) {
    const url = `${PERFORMANCE_API_URL}/admin/referral/${referralId}`;
    return fmhAPI.base
        .url(url)
        .get()
        .notFound(() => [])
        .json();
}

export async function deletePerformanceReqirements(body) {
    const url = `${PERFORMANCE_API_URL}/admin/remove-performance`;
    return fmhAPI.base.url(url).post(body).json();
}

export async function addPerformanceRequirement(body) {
    const url = `${PERFORMANCE_API_URL}/admin/add-performance`;
    return fmhAPI.base.url(url).post(body).json();
}

/** Attaches one ad-hoc value case to every referral in the file, or saves nothing. */
export async function addBulkAdHocPerformance({
    payerId,
    segmentId,
    reason,
    valueCaseName,
    performanceStartDate,
    file,
}) {
    const url = `${PERFORMANCE_API_URL}/admin/add-performance/bulk`;
    return fmhAPI.base
        .url(url)
        .query({
            payer_id: payerId,
            segment_id: segmentId,
            reason,
            value_case_name: valueCaseName,
            performance_start_date: performanceStartDate,
        })
        .formData({ file })
        .post()
        .json();
}
